import { render, staticRenderFns } from "./AttachTeacher.vue?vue&type=template&id=e26a8232&scoped=true&"
import script from "./AttachTeacher.vue?vue&type=script&lang=js&"
export * from "./AttachTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AttachTeacher.vue?vue&type=style&index=0&id=e26a8232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26a8232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VForm})
